// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jnrS","question":"styles_question__35UBj","inputVisibleButton":"styles_inputVisibleButton__1WwQF","note":"styles_note__Rem_n"};